import React, { Component } from 'react'
import { connect } from 'react-redux'

const tosContainer = (ComposedComponent) => {
    class TOSContainer extends Component {
        render () {
            return (
                <ComposedComponent {...this.props} />
            )
        }
    }
    const mapStateToProps = ({
        langs: { indexLang },
    }) => ({
        indexLang,
    })
    return connect(mapStateToProps)(TOSContainer)
}

export default tosContainer
